import React, {useEffect, useMemo, useRef, useState} from "react";
import {MenuOverViewWrap, DropDown, AddNewDropDown} from "components/atoms/MenuManagement/Overview/Overview.styles";
import Button from "components/molecules/Button";
import Form from "components/molecules/Form/Form";
import Field from "components/molecules/Field";
import {useForm} from "components/molecules/Form";
import {FiSearch} from "react-icons/fi";
import {FaRegEdit} from "react-icons/fa";
import {IoMdArrowDropdown} from "react-icons/io";
import AddNewItem from "components/atoms/MenuManagement/AddNewItem/Index";
import item from "assets/item.svg";
import menuIcon from "assets/menu.svg";
import category from "assets/category.svg";
import AddMenu from "components/atoms/MenuManagement/AddMenu";
import MenuButton, {MenuItem} from "components/atoms/Menu/Menu";
import CopyStore from "components/atoms/MenuManagement/CopyStore/Index";
import ModalContainer from "components/molecules/ModalContainer";
import AddCategory from "components/atoms/MenuManagement/CategoryModal";
import menuStoreService from "services/menu-storeService";
import {useAuthContext} from "Context/authContext";
import {useSelector} from "react-redux";
import CenterModal from "components/molecules/Modal/CenterModal";
import ItemPreviewModal from "../ItemPreviewModal";
import Toast from "components/molecules/Toast";
import MenuManagementAccor from "components/atoms/MenuManagement";
const MenuOverview = ({selectedMenu, setSelectedMenu, currentStoreId, selected, setSelected, handelSelected, handelApi}) => {
    const [form] = useForm();
    const [menuLabel, setMenuLabel] = useState();
    const [startTime, setStartTime] = useState();
    const [previewModal, setPreviewModal] = useState(false);
    const [payload, setPayload] = useState(null);
    const [categoryModal, setCategoryModal] = useState(false);
    const [newMenuId, setNewMenuId] = useState(null);
    const [newCategoryId, setNewCategoryId] = useState(null);
    
    // Debug logging for modal state changes
    useEffect(() => {
        console.log("categoryModal state changed:", categoryModal);
    }, [categoryModal]);
    
    useEffect(() => {
        console.log("newMenuId state changed:", newMenuId);
    }, [newMenuId]);
    const [itemModal, setItemModal] = useState(false);
    const [endTime, setEndTime] = useState();
    const [isDropdown, setIsDropdown] = useState(false);
    const {fetch} = useAuthContext();
    const defaultStore = useSelector(state => state.business.defaultStore);
    const dropdownRef = useRef(null);
    const dropdownIconRef = useRef(null);
    const handleClickOutside = event => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !dropdownIconRef.current.contains(event.target)) {
            setIsDropdown(false);
        }
    };
    
    // Use currentStoreId if provided, otherwise fallback to defaultStore
    const storeId = currentStoreId || defaultStore;
    const {menu_data} = menuStoreService.GetBranchMenu(storeId, fetch);

    const menu = useMemo(() => {
        if (!menu_data) {
            return [];
        }
        return menu_data?.menus?.map(menu => ({
            value: menu._id,
            label: menu.menuTitle,
            startTime: menu?.startTime,
            endTime: menu?.endTime,
        }));
    }, [menu_data]);

    // Get menu overview data
    const [menuOverview, setMenuOverview] = useState();

    const getMenuOverview = async () => {
        if (storeId) {
            try {
                console.log("MenuOverview: Fetching menu overview for store:", storeId);
                const res = await menuStoreService.getMenuOverview(storeId);
                setMenuOverview(res?.data);
            } catch (error) {
                console.error("Error fetching menu overview:", error);
            }
        }
    };

    useEffect(() => {
        getMenuOverview();
    }, [storeId, fetch]);

    useEffect(() => {
        if (menu && menu.length > 0) {
            setMenuLabel(menu[0]?.label);
            setSelectedMenu(menu[0]?.value);
            setStartTime(menu[0]?.startTime);
            setEndTime(menu[0]?.endTime);
        }
    }, [menu_data, menu]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const {hasPermission} = useAuthContext("hasPermission");

    return (
        <>
            <MenuOverViewWrap>
                <div className="text-wrap">
                    <div className="left-content">
                        <div className="dropdown-btn">
                            <MenuButton
                                top="5px !important"
                                transition
                                text={menuLabel || "Select Menu"}
                                icon={<IoMdArrowDropdown size={20} className="list-icon" />}>
                                {menu?.map((item, index) => (
                                    <MenuItem
                                        className="item"
                                        key={index}
                                        onClick={() => {
                                            setSelectedMenu(item?.value);
                                            setMenuLabel(item?.label);
                                            setStartTime(item?.startTime);
                                            setEndTime(item?.endTime);
                                        }}>
                                        {item?.label}
                                    </MenuItem>
                                ))}
                            </MenuButton>
                        </div>
                        <div className="inner">
                            <p>
                                Every day from {startTime} - {endTime}
                            </p>
                            {hasPermission("menu-management.edit-menu") && (
                                <div className="edit-btn">
                                    <ModalContainer
                                        width={850}
                                        noBorder
                                        title="Edit Menu"
                                        btnComponent={({onClick}) => (
                                            <Button sm onClick={onClick}>
                                                <FaRegEdit />
                                                Edit Menu
                                            </Button>
                                        )}
                                        content={({onClose}) => (
                                            <AddMenu
                                                btnText="Save Items"
                                                editMenu={true}
                                                menuId={selectedMenu}
                                                onClose={onClose}
                                            />
                                        )}
                                    />
                                </div>
                            )}
                        </div>
                        <Form form={form}>
                            <Form.Item
                                type="search"
                                rounded
                                name="search"
                                lg
                                placeholder="Search...."
                                $bgWhite
                                inputSm
                                noMargin
                                suffix={<FiSearch />}>
                                <Field />
                            </Form.Item>
                        </Form>
                    </div>
                    <div className="right-content">
                        <div className="dropdownWrap">
                            <div className="btn">
                                <CenterModal
                                    open={previewModal}
                                    setOpen={setPreviewModal}
                                    width={700}
                                    title="Customer Preview">
                                    <ItemPreviewModal payload={payload} item={item} />
                                </CenterModal>
                                <MenuButton
                                    top="45px !important"
                                    transition
                                    text="Add New"
                                    icon={<IoMdArrowDropdown size={20} className="list-icon" />}>
                                    {hasPermission("menu-management.add-menu") && (
                                        <ModalContainer
                                            width={850}
                                            title="Add New Menu"
                                            btnComponent={({onClick}) => (
                                                <MenuItem className="item" onClick={onClick}>
                                                    <img src={menuIcon} alt="menu" /> Menu
                                                </MenuItem>
                                            )}
                                            content={({onClose}) => (
                                                <AddMenu
                                                    onClose={onClose}
                                                    handleCategoryModal={(menuId) => {
                                                        console.log("handleCategoryModal called with menuId:", menuId);
                                                        if (menuId) {
                                                            setNewMenuId(menuId);
                                                        }
                                                        setCategoryModal(true);
                                                        console.log("Category modal should now be open");
                                                    }}
                                                />
                                            )}
                                        />
                                    )}
                                    {hasPermission("menu-management.add-item") && (
                                        <>
                                            <MenuItem
                                                className={`item ${!selectedMenu ? "disabled" : ""}`}
                                                onClick={() => {
                                                    if (selectedMenu) {
                                                        setItemModal(true);
                                                    } else {
                                                        Toast({
                                                            type: "error",
                                                            message: "Please select a menu first to add items"
                                                        });
                                                    }
                                                }}>
                                                <img src={item} alt="item" /> Item
                                            </MenuItem>
                                            <CenterModal
                                                open={itemModal}
                                                setOpen={setItemModal}
                                                width={850}
                                                title="Add New Item">
                                                <AddNewItem
                                                    menuId={newMenuId || selectedMenu}
                                                    btnText="Save Items"
                                                    categoryId={newCategoryId}
                                                    currentStoreId={currentStoreId}
                                                    onClose={() => {
                                                        setItemModal(false);
                                                        setNewCategoryId(null);
                                                        setNewMenuId(null); // Clear newMenuId when item modal closes
                                                    }}
                                                    setPreviewModal={setPreviewModal}
                                                    setPayload={setPayload}
                                                />
                                            </CenterModal>
                                            {/* <ModalContainer
                                                width={850}
                                                title="Add New Item"
                                                btnComponent={({onClick}) => (
                                                    <MenuItem
                                                        className={`item ${!selectedMenu ? "disabled" : ""}`}
                                                        onClick={onClick}>
                                                        <img src={item} alt="item" /> Item
                                                    </MenuItem>
                                                )}
                                                content={({onClose}) => (
                                                    <AddNewItem
                                                        menuId={selectedMenu}
                                                        btnText="Save Items"
                                                        onClose={onClose}
                                                        currentStoreId={currentStoreId}
                                                        setPreviewModal={setPreviewModal}
                                                        setPayload={setPayload}
                                                    />
                                                )}
                                            /> */}
                                        </>
                                    )}

                                    {hasPermission("menu-management.add-category") && (
                                        <>
                                            <MenuItem
                                                className={`reject ${!selectedMenu ? "disabled" : ""}`}
                                                onClick={() => setCategoryModal(true)}>
                                                <img src={category} alt="reject" /> Category
                                            </MenuItem>

                                            <CenterModal
                                                open={categoryModal}
                                                setOpen={setCategoryModal}
                                                width={850}
                                                title="Create Category">
                                                <AddCategory
                                                    menuId={newMenuId || selectedMenu}
                                                    onClose={() => {
                                                        setCategoryModal(false);
                                                        // Don't clear newMenuId here - keep it for item modal
                                                    }}
                                                    handleItemModal={(categoryId) => {
                                                        setItemModal(true);
                                                        setNewCategoryId(categoryId);
                                                    }}
                                                />
                                            </CenterModal>
                                        </>
                                    )}
                                </MenuButton>
                            </div>
                        </div>
                    </div>
                </div>
            </MenuOverViewWrap>
            
            {/* Render Menu Accordions */}
            {menuOverview && menuOverview.length > 0
                ? menuOverview.map((menu, menuIndex) => (
                      <div key={menu._id}>
                          {menu.categories && menu.categories.length > 0
                              ? menu.categories.map((elem, ind) => (
                                    <MenuManagementAccor
                                        key={elem._id}
                                        setSelected={setSelected}
                                        selected={selected}
                                        menuId={menu._id}
                                        rowData={elem}
                                        ind={ind}
                                        handelSelected={handelSelected}
                                        handelApi={handelApi}
                                    />
                                ))
                              : ""}
                      </div>
                  ))
                : ""}
        </>
    );
};

export default MenuOverview;
